import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import firebase from 'firebase/app'
import moment from 'moment'
import _ from 'lodash'
import { isMobile } from 'react-device-detect'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericRange from '../../GenericComponents/GenericRange'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'

import AppContext from '../../context/appContext'
import changeLocation from '../../utils/changeLocalization'

import {
  setHydrationAlert,
  getHydrationAlert,
  patchHydrationAlert,
  getUserData,
  getUserFeed,
  getTrainingDays,
  getUserChatName,
  editUserChatName,
} from '../../Api/backendApi'
import { patchDiet } from '../../Api/dietApi/userInfo'

import FitmatkaImage from '../../assets/REDESIGN_Assets/ChatBox/chatbox-fitmatka-image.webp'
import FitmatkaLogo from '../../assets/REDESIGN_Assets/ChatBox/logo-image.webp'

import EnterChatName from './views/EnterChatName'
import ChatBoxView from './views/ChatBoxView'

import { ChatBoxBox, ChatBoxColumn } from './style/ChatBoxStyle'
interface ChatBoxInterface {}

const ChatBox: FC<ChatBoxInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const [user, setUser] = useState(Object)
  const [chatName, setChatName] = useState('')
  const [chatBoxPage, setChatBoxPage] = useState(0)
  const [loadingUserName, setLoadingUserName] = useState(false)
  const [messages, setMessages] = useState(Object)
  const [unsortedMessages, setUnsortedMessages] = useState(Object)

  useEffect(() => {
    obtainUser()
    obtainUserChatName()
    obtainMessages()
  }, [])

  useEffect(() => {
    const sorted = _.sortBy(unsortedMessages, 'timestamp.seconds')
    setMessages(sorted)
  }, [unsortedMessages])

  useEffect(() => {
    // manageChatBoxPage()
  }, [loadingUserName])

  const manageChatBoxPage = () => {
    if (chatName !== '') {
      setChatBoxPage(chatBoxPage + 1)
    }
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()

    setUser(user)
    appContext.updateAppState('user', user)
  }

  const obtainUserChatName = async () => {
    setLoadingUserName(true)
    if (appContext.appState.chatName) {
      setUser(appContext.appState.chatName)
    }

    const name: any = await getUserChatName()

    setChatName(name)
    appContext.updateAppState('chatName', name)
    setLoadingUserName(false)
  }

  const handleChatEditNameInput = (value: any) => {
    setChatName(value)
  }

  const handleJoinChatButtonClick = () => {
    if (chatName.length < 3) {
      notify.show(`Proszę wpisz imię`, 'error', 3000)
    } else {
      editUserChatName(chatName)
      setTimeout(() => {
        setChatBoxPage(chatBoxPage + 1)
      }, 500)
    }
  }

  const obtainMessages = () => {
    // test chat 98C6C14ACCE440C6AB3058D2970D5A0F
    // prod chat 0e23f94f1435d2e63d39865c407d847f

    firebase
      .firestore()
      .collection('0e23f94f1435d2e63d39865c407d847f')
      .orderBy('timestamp', 'desc')
      .limit(100)
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data())

        setUnsortedMessages(data)
      })
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      }`}
    >
      <NavigationBar
        isPlayerView={false}
        backButtonAction={() => changeLocation('/trening')}
      />
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={() => changeLocation('/twoj-profil')}
        />
      )}
      <ChatBoxBox>
        {!isMobile ? (
          <ChatBoxColumn>
            <GenericIcon
              position={'absolute'}
              top={'1%'}
              left={'20%'}
              src={FitmatkaImage}
              width={'40vw'}
              height={'90vh'}
            ></GenericIcon>
            <GenericIcon
              position={'absolute'}
              top={'68%'}
              left={'33%'}
              backgroundSize={'contain'}
              src={FitmatkaLogo}
              width={'25%'}
              height={'30%'}
              zIndex={'2'}
            ></GenericIcon>
          </ChatBoxColumn>
        ) : null}
        <ChatBoxColumn
          justify={chatBoxPage == 1 && 'flex-start'}
          // margin={chatBoxPage == 1 && '15% 0 0 0'}
        >
          {chatBoxPage == 0 ? (
            <EnterChatName
              chatName={chatName}
              handleJoinChatButtonClick={handleJoinChatButtonClick}
              handleChatEditNameInput={handleChatEditNameInput}
            />
          ) : (
            <ChatBoxView messages={messages} chatName={chatName} user={user} />
          )}
        </ChatBoxColumn>
      </ChatBoxBox>
    </GenericBackgroundLayer>
  )
}

export default ChatBox
